interface StandardContainerProps {
  children: React.ReactNode;
  'data-testid'?: string;
}

export const StandardContainer: React.FC<StandardContainerProps> = ({
  children,
  'data-testid': testId,
}) => (
  <section 
    data-testid={testId}
    className="grid grid-cols-1 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8"
  >
    {children}
  </section>
);
